import { call, put, takeEvery } from 'redux-saga/effects';
import ServiceRequestAction, {
  ServiceRequestTypes,
} from 'redux/actions/serviceRequestAction';
import { CatalogServices } from 'services';
import BaseAction from '../actions/baseAction';

export function* getListCatalog(action: any): any {
  try {
    const result = yield call(CatalogServices.getListCatalog, action?.params);
    yield put(ServiceRequestAction.getListCatalogSuccess(result.data));
  } catch (error) {
    yield put(ServiceRequestAction.setLoading(false));
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_CATALOG ${error}`,
      }),
    );
  }
}

export const watchServiceRequest = [
  takeEvery(ServiceRequestTypes.GET_LIST_CATALOG, getListCatalog),
];
